import React from 'react';
import Page from '../../components/Page';
import privacy from './privacy.md';

function action() {
  return {
    chunks: ['privacy'],
    title: privacy.title,
    component: <Page {...privacy} />,
  };
}

export default action;
